import { render, staticRenderFns } from "./previewGiftAndOrder.vue?vue&type=template&id=a948c4b8&scoped=true&"
import script from "./previewGiftAndOrder.vue?vue&type=script&lang=js&"
export * from "./previewGiftAndOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a948c4b8",
  null
  
)

export default component.exports